<ng-container *ngIf="!menuapp">
	<form [formGroup]="searchForm" class="m-0 p-0">
		<div class="main_card m-0 p-0">
			<div class="row m-0 p-0">
				<div class="col-12">
					<h3> Sales Trends 8 week (Top 100 items)</h3>
				</div>
			</div>
			<div class="row m-0 p-0">
				<!-- <div class="col-xs-12 col-md-3 col-3">
					<mat-form-field appearance="outline" class="amount-text">
						<mat-label>Limit</mat-label>
						<input matInput type="text" formControlName="limit" class="text-right " />
					</mat-form-field>
				</div> -->
				<div class="col-xs-12 col-md-3 col-3">
					<span *ngIf="sending">
						<svg class="spinner" width="35px" height="35px" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
							<circle class="path" fill="none" stroke-width="6" stroke-linecap="round" cx="33" cy="33" r="30"></circle>
						</svg>
					</span>
					&nbsp;&nbsp; <button class="btn btn-success btn-sm" (click)="$event.preventDefault();exportXls()" *ngIf="!sending">
						<i class="fa fa-file-excel-o"></i> XLS
					</button>
					&nbsp;&nbsp;
					<button class="btn btn-danger btn-sm" (click)="$event.preventDefault();exportPdf()" *ngIf="!sending">
						<i class="fa fa-file-pdf-o"></i> PDF
					</button>
					&nbsp;&nbsp;
					<button mat-raised-button color="accent" class="mt-2" (click)="getData()" *ngIf="!sending">
						<mat-icon>refresh</mat-icon>
					</button>
				</div>
			</div>
		</div>
	</form>
	<div #print_table class="m-0 p-0 card shadow-sm rounded-3 border-0">

	  <!-- Summary Cards -->
	  <!-- <div class="row m-0 p-0 g-3 mb-3" *ngIf="summary"> -->
		<!-- <div class="col-md-4">
		  <div class="card shadow-sm border-primary">
			<div class="card-body text-center">
			  <h6 class="text-muted">Total SKUs Purchased</h6>
			  <h4 class="text-primary m-0">{{ summary.total_skus }}</h4>
			</div>
		  </div>
		</div> -->
		<!-- <div class="col-md-6">
		  <div class="card shadow-sm border-success">
			<div class="card-body text-center">
			  <h6 class="text-muted">Total Units (8 Weeks)</h6>
			  <h4 class="text-success m-0">{{ summary.total_units }}</h4>
			</div>
		  </div>
		</div>
		<div class="col-md-6">
		  <div class="card shadow-sm border-info">
			<div class="card-body text-center">
			  <h6 class="text-muted">Average Price per Unit</h6>
			  <h4 class="text-info m-0">{{ summary.avg_price_per_unit | currency }}</h4>
			</div>
		  </div>
		</div>
	  </div> -->

	  <!-- Quick Insights -->
	  <!-- <div class="row g-3 mb-4" *ngIf="summary">
		<div class="col-md-6">
		  <div class="alert alert-warning">
			<strong>Trial Behavior:</strong>
			{{ summary.trial_behavior_count }} SKUs had a one-time spike.
		  </div>
		</div>
		<div class="col-md-6">
		  <div class="alert alert-secondary">
			<strong>Repeat Behavior:</strong>
			{{ summary.repeat_behavior_count }} SKUs show consistent purchasing patterns.
		  </div>
		</div>
	  </div> -->

	  <!-- Report Table -->
	  <div class="card-body m-0 p-0">
		<div class="table-responsive">
		  <table class="table table-striped table-hover table-bordered align-middle text-center m-0">
			<!-- <thead class="thead-dark">
			  <tr>
				<th (click)="sortBy('stockid')" class="cursor-pointer">Item #</th>
				<th (click)="sortBy('description')" class="cursor-pointer text-start">Description</th>
				<th (click)="sortBy('salestotal')" class="cursor-pointer">Total Sales</th>
				<th (click)="sortBy('qtytotal')" class="cursor-pointer">Qty</th>
				<th (click)="sortBy('frequency')" class="cursor-pointer">Frequency</th>
				<th (click)="sortBy('trend_label')" class="cursor-pointer">Trend</th>
				<th (click)="sortBy('avg_weekly')" class="cursor-pointer">Avg/Wk</th>
				<th (click)="sortBy('one_time_spike')" class="cursor-pointer">Trial?</th>
				<th (click)="sortBy('action_recommendation')" class="cursor-pointer">Recommended Action</th>
			  </tr>
			</thead> -->
			<!-- <tbody>
			  <tr *ngFor="let r of sortedReportResults">
				<td class="fw-semibold">{{ r.stockid }}</td>
				<td class="text-start">{{ r.description }}</td>
				<td>{{ r.salestotal | currency }}</td>
				<td>{{ r.qtytotal | number }}</td>
				<td>{{ r.frequency }}</td>
				<td>
				  <span class="badge px-2 py-1"
					[ngClass]="{
					  'bg-success text-light': r.trend_label === 'Stable',
					  'bg-warning text-dark': r.trend_label === 'Low Activity',
					  'bg-danger text-light': r.trend_label === 'One-Time Spike',
					  'bg-primary': r.trend_label === 'Upward',
					  'bg-info text-dark': r.trend_label === 'Spike',
					  'bg-dark': r.trend_label === 'Downward',
					  'bg-secondary': r.trend_label === 'Volatile'
					}">
					{{ r.trend_label }}
				  </span>
				</td>
				<td>{{ r.avg_weekly | number:'1.2-2' }}</td>
				<td>
				  <span class="badge rounded-pill px-3"
					[ngClass]="{
					  'bg-danger text-light': r.one_time_spike,
					  'bg-secondary': !r.one_time_spike
					}">
					{{ r.one_time_spike ? 'Yes' : 'No' }}
				  </span>
				</td>
				<td>
				  <span class="badge px-2"
					[ngClass]="{
					  'bg-secondary': r.action_recommendation.startsWith('Monitor'),
					  'bg-success text-light': r.action_recommendation.startsWith('High Growth'),
					  'bg-info text-dark': r.action_recommendation.startsWith('Reliable Buyer'),
					  'bg-warning text-dark': r.action_recommendation.includes('Low'),
					  'bg-danger text-light': r.action_recommendation.includes('Spike') || r.action_recommendation.includes('Falling') || r.action_recommendation.includes('Unstable')
					}">
					{{ r.action_recommendation }}
				  </span>
				</td>
			  </tr>
			</tbody> -->
			<thead class="thead-dark">
			  <tr>
				<th (click)="sortBy('stockid')" class="cursor-pointer">Item #</th>
				<th (click)="sortBy('description')" class="cursor-pointer text-start">Description</th>
				<th (click)="sortBy('salestotal')" class="cursor-pointer">Total Sales</th>
				<th (click)="sortBy('qtytotal')" class="cursor-pointer">Quantity</th>
				<th (click)="sortBy('frequency')" class="cursor-pointer">Frequency</th>
				<!-- <th (click)="sortBy('avg_weekly')" class="cursor-pointer">Avg/Wk</th> -->
				<th (click)="sortBy('avg_price')" class="cursor-pointer">Avg Price</th>
				<th (click)="sortBy('volatility')" class="cursor-pointer">Volatility</th>
				<th (click)="sortBy('slope')" class="cursor-pointer">Slope</th>
				<th (click)="sortBy('one_time_spike')" class="cursor-pointer">Trial?</th>
			  </tr>
			</thead>
			<tbody>
			  <tr *ngFor="let r of sortedReportResults">
				<td class="fw-semibold">{{ r.stockid }}</td>
				<td class="text-start">{{ r.description }}</td>
				<td>{{ r.salestotal | currency }}</td>
				<td>{{ r.qtytotal | number }}</td>
				<td>{{ r.frequency }}</td>
				<!-- <td>{{ r.avg_weekly | number:'1.2-2' }}</td> -->
				<td>{{ r.avg_price | currency }}</td>
				<td>{{ r.volatility | number:'1.2-2' }}</td>
				<td>{{ r.slope | number:'1.2-2' }}</td>
				<td>
				  <span class="badge rounded-pill px-3"
					[ngClass]="{
					  'bg-danger text-light': r.one_time_spike,
					  'bg-secondary': !r.one_time_spike
					}">
					{{ r.one_time_spike ? 'Yes' : 'No' }}
				  </span>
				</td>
			  </tr>
			</tbody>
		  </table>

		  <!-- Spinner -->
		  <div class="d-flex justify-content-center p-4" *ngIf="loading">
			<svg class="spinner" width="65px" height="65px" viewBox="0 0 66 66"
				 xmlns="http://www.w3.org/2000/svg">
			  <circle class="path" fill="none" stroke-width="6"
					  stroke-linecap="round" cx="33" cy="33" r="30"></circle>
			</svg>
		  </div>
		</div>
	  </div>
	</div>

</ng-container>
